<template>
    <div>
        <div style="text-align: center;">
            <v-text-field placeholder="可以输入缓存的KEY直接清除" v-model="key"></v-text-field>
            <v-btn color="primary" @click="onClear">清除</v-btn>
        </div>
        <div>
            <v-data-table :headers="headers" :items="items" class="elevation-1" item-key="name" :search="key">
                <template v-slot:items="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.expired }}</td>
                    <td>{{ props.item.value }}</td>
                    <td><v-icon v-if="props.item.expired == 'N'" style="cursor: pointer;"
                            @click="onClearByList(props.index)">delete</v-icon>&nbsp;</td>
                </template>
            </v-data-table>
        </div>
    </div>
</template>
<script>
export default {
    name: "cache-manager",
    data() {
        return {
            key: null,
            headers: [{ text: '缓存KEY', value: 'name' }, { text: '过期', value: 'expired' }, { text: '时间信息', value: 'value', sortable: false }, { text: '操作', sortable: false }],
            items: [],
        };
    },
    methods: {
        onClear() {
            let self = this;
            if (!self.key) {
                return;
            }
            self.$axios.get(`/home/admin/sys/cache/clear/${self.key}`).then(() => {
                self.$status('清除成功～', 'success');
            });
        },
        onClearByList(idx) {
            let self = this, items = self.items, item = items[idx];
            self.$axios.get(`/home/admin/sys/cache/clear/${item.name}`).then(() => {
                self.$status('清除成功～', 'success');

            });
        }
    },
    created() {
        let self = this;
        self.$axios.get('/home/admin/sys/cache/list').then((r) => {
            let items = r.data.message;
            for (let item of items) {
                let arr = item.value.split('/');
                item.expired = parseInt(arr[0]) > parseInt(arr[1]) ? "Y" : "N";
            }
            self.items = items;
        });
    }
};
</script>